<template>
  <section style="width: 1200px; margin: auto">
    <div class="container-fluid cl-footer">
      <div class="container">
        <ul class="clearfix flex">
          <li class="left li">{{ $t("关于我们") }}</li>
          <li class="left li">{{ $t("联系我们") }}</li>
          <li class="left li">{{ $t("意见反馈") }}</li>
          <li class="left li">{{ $t("隐私与政策") }}</li>
          <li class="left li">{{ $t("用户注册协议") }}</li>
        </ul>
        <ul class="clearfix flex">
          <li class="left">{{ dataInfo.web_site_copyright }}</li>
          <li class="left">陕ICP备11041704号</li>
          <li class="left">陕公网安备 11000002000088号</li>
        </ul>
        <ul class="clearfix flex">
          <li class="left">
            <img src="../imgs/anzhuo.png" alt="" />
            <p>Android</p>
          </li>
          <li class="left">
            <img src="../imgs/anzhuo.png" alt="" />
            <p>IOS</p>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import api from "@/api/request1";
export default {
  name: "footer",
  data() {
    return {
      dataInfo: {},
    };
  },
  mounted() {
    this.getMessage();
  },
  methods: {
    getMessage() {
      api.post62fb8dc3857d1().then((res) => {
        if (res.code != 1) {
          this.$message.info(res.msg);
          return;
        }
        this.dataInfo = res.data;
        localStorage.setItem("KEFU_INFO", JSON.stringify(this.dataInfo));
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "themePath/footer";
</style>



// WEBPACK FOOTER //
// src/components/footerBtn.vue